import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'
import {
    BidsGetBidsParamsT,
    BidsGetBidsResponseT,
    BidsGetBidsOnSignParamsT,
    BidsGetBidsOnSignResponseT,
    BidsGetBidResponseT,
    BidsGetBidStatusesResponse,
    BidsGetFtlExcelParams,
    BidsEditSignersPayload,
    GetBidByIdDovogor24Response,
} from '../types/bids.types'

export class BidsRepository {
    resendToContract(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/tms/api/bid/${id}/resend-to-contract`, { id })
    }

    resendToContractFtl(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/bid/${id}/resend-to-contract`, { id })
    }

    getBid(id: number): Promise<AxiosResponse<BidsGetBidResponseT>> {
        return http.get(`/cabinet/api/bid/${id}`)
    }

    getBidNew(id: number): Promise<AxiosResponse<BidsGetBidResponseT>> {
        return http.get(`/tms/api/bid/${id}`)
    }

    getBids(params: BidsGetBidsParamsT): Promise<AxiosResponse<BidsGetBidsResponseT>> {
        return http.get('/cabinet/api/bid', { params })
    }

    getLogistBidStatuses(): Promise<AxiosResponse<BidsGetBidStatusesResponse>> {
        return http.get('/cabinet/api/dictionaries/bid-statuses')
    }

    getTmsBids(params: BidsGetBidsParamsT): Promise<AxiosResponse<BidsGetBidsResponseT>> {
        return http.get('/tms/api/bid', { params })
    }

    getDogovor24ById(bidId: number): Promise<AxiosResponse<GetBidByIdDovogor24Response>> {
        return http.get(`/contract/api/dogovor24/bid/${bidId}`)
    }

    getBidsOnSign(
        params: BidsGetBidsOnSignParamsT
    ): Promise<AxiosResponse<BidsGetBidsOnSignResponseT>> {
        return http.get('/contract/api/dogovor24/bids', { params })
    }

    createBidFtl(id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl-bid/${id}/logistic-bid`, payload)
    }

    createBid(payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/cabinet/api/bid', payload)
    }

    deleteBid(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/bid/${id}`)
    }

    deleteTmsBid(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/tms/api/bid/${id}`)
    }

    downloadContract(bid_id: number): Promise<AxiosResponse<any>> {
        return http.get(`/contract/api/contract/additional-document/${bid_id}/download-bid`, {
            responseType: 'blob',
        })
    }

    editSigners(id: number, payload: BidsEditSignersPayload): Promise<AxiosResponse<any>> {
        return http.put(`/contract/api/dogovor24/change-signer/${id}`, payload)
    }

    downloadFtlBidsExcel(params: BidsGetFtlExcelParams): Promise<AxiosResponse<any>> {
        return http.get('/cabinet/api/bid/export', {
            responseType: 'blob',
            params,
        })
    }
}
